<template>
    <div style="text-align: center">
        <ContentRenderer v-if="!hide" :content="measure.content"></ContentRenderer>
        <v-btn v-if="initiated" color="primary" @click="next()">{{$t('general.continue')}}</v-btn>
    </div>
</template>

<script>
  import ContentRenderer from "../content/ContentRenderer";
  import applicationEventHub from "../../events/applicationEventHub";
  export default {
    name: "MeasureIntro",
    components:{
      ContentRenderer
    },
    computed:{
      measure(){
        return this.$store.state.assessment.journeyplan.measure;
      },
      journeyplan(){
        return this.$store.state.assessment.journeyplan;
      },
    },
    data(){
      return {
        hide : false,
        initiated : false
      }
    },
    mounted(){
      applicationEventHub.frameworkNavigationDisplay(true);
      applicationEventHub.$on('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,false);
      setTimeout(()=>{
        this.initiated=true;
      },800);
    },
    methods:{
      next(){
        this.hide=true;
        this.$nextTick(()=>{
          this.$store.dispatch('assessment/setMeasureIntroDisplayed',this.journeyplan.journeyplanid);
        });
      }
    },
    beforeDestroy() {
      applicationEventHub.$off('framework.next',this.next);
      applicationEventHub.frameworkButtonState(true,true);
      applicationEventHub.frameworkNavigationDisplay(false);
    }
  }
</script>

<style scoped>

</style>